export enum LabelAlignmentIdentifier {
	Left = 0,
	Center,
	Right,
	Top,
	Middle,
	Bottom
}
